<template>
  <base-button
    :aria-label="paused ? $t.videoPlay : $t.videoPause"
    class="@hactive:c-grey-60"
  >
    <vf-icon :name="paused ? 'play' : 'pause'" :size />
  </base-button>
</template>

<script setup lang="ts">
import type { Responsive } from '#types/common'
import type { IconSizes } from '#types/sizes'

defineProps<{
  paused?: boolean
  size?: IconSizes | Partial<Responsive<IconSizes>>
}>()
</script>
